package com.dotdrives.design

/**
 * Deterministic avatar colors shared by web and Compose.
 *
 * Hash algorithm: start with Int 0, then for each UTF-16 code unit use
 * `hash = hash * 31 + char.code` with normal 32-bit two's-complement overflow.
 * Interpret the final Int as unsigned and take modulo five.
 */
object DotAvatarPalette {
    private val tints = listOf(
        DotColors.PRIMARY_TINT to DotColors.PRIMARY_TINT_TEXT,
        DotColors.SUCCESS_TINT to DotColors.SUCCESS_TEXT,
        DotColors.INFO_TINT to DotColors.INFO_TEXT,
        DotColors.AUTOMATION_TINT to DotColors.AUTOMATION,
        DotColors.WARNING_TINT to DotColors.WARNING_TEXT,
    )

    fun tintFor(seed: String): Pair<String, String> {
        var hash = 0
        seed.forEach { char ->
            hash = hash * 31 + char.code
        }
        val index = (hash.toUInt() % tints.size.toUInt()).toInt()
        return tints[index]
    }
}
